/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useMemo, memo } from 'react'
import {
  FlatList,
  View,
  Dimensions,
  ScrollView,
  TouchableOpacity,
  ImageBackground,
  StatusBar,
} from 'react-native'
import { SafeAreaView, useSafeAreaInsets } from 'react-native-safe-area-context'
import PropTypes from 'prop-types'
import ContentLoader, { Rect } from 'react-content-loader/native'
import { NavigationContainer } from '@react-navigation/native'
import { createMaterialTopTabNavigator } from '@react-navigation/material-top-tabs'
import { TabBar } from 'react-native-tab-view'
import { Icon, VFButton } from '@vfgroup-oneplatform/foundation/Components'
import ContentManager from '@vfgroup-oneplatform/foundation/ContentManager'
import { Colors } from '@vfgroup-oneplatform/foundation/Components/Themes'

import VfText from '../../Components/VfText'
import Browser from '../../Components/Browser'

import images from '../../Themes/Images'
import styles from './GigaProductInfo.Styles'

const Tab = createMaterialTopTabNavigator()
const { width, height } = Dimensions.get('window')
const initialLayout = {
  height: 0,
  width: width,
}

console.disableYellowBox = true

const Item = memo(function ListItem({ name, i }) {
  return (
    <View key={'item-' + i} style={styles.itemContainer}>
      <Icon
        name={images.tv}
        size={32}
        type="image"
        resizeMode="contain"
        style={styles.itemIcon}
      />
      <VfText i18nKey={name} />
    </View>
  )
})
Item.propTypes = {
  i: PropTypes.number,
  name: PropTypes.string,
}

const EmptyList = memo(function ListEmpty() {
  return (
    <View style={styles.itemContainer}>
      <Icon
        name={images.notFound}
        size={32}
        type="image"
        resizeMode="contain"
        style={styles.itemIcon}
      />
      <VfText i18nKey="No channels found" />
    </View>
  )
})

const List = memo(function ListComponent({ items, i }) {
  return (
    <FlatList
      key={'listKey-' + i}
      listKey={'list-' + i}
      nestedScrollEnabled={true}
      showsVerticalScrollIndicator={false}
      contentContainerStyle={styles.listContentContainer}
      style={styles.list}
      ItemSeparatorComponent={() => <View style={styles.listSeparator} />}
      ListEmptyComponent={<EmptyList />}
      keyExtractor={index => 'item-' + index}
      data={items}
      renderItem={({ item, index }) => <Item i={index} name={item.name} />}
    />
  )
})

List.propTypes = {
  items: PropTypes.array,
  i: PropTypes.number,
}

const TabRoutes = memo(function TabBarComponent({ tabProps, lastIndex }) {
  return (
    <TabBar
      {...tabProps}
      scrollEnabled
      style={styles.tabbar}
      tabStyle={styles.tabStyle}
      renderIndicator={() => null}
      renderLabel={({ route, focused }) => {
        const {
          name,
          params: { index },
        } = route

        let color = Colors.thinDark,
          bgColor = Colors.white,
          borderColor = Colors.veryLightPinkTwo

        if (focused) {
          color = Colors.white
          bgColor = Colors.ocean
          borderColor = Colors.ocean
        }

        const style = {}
        if (index === 0) {
          style.marginLeft = 16
        }
        if (index === lastIndex) {
          style.marginRight = 16
        }

        return (
          <VfText
            i18nKey={name}
            color={color}
            align="center"
            style={[
              styles.labelContainer,
              {
                borderColor: borderColor,
                backgroundColor: bgColor,
              },
              style,
            ]}
          />
        )
      }}
    />
  )
})
TabRoutes.propTypes = {
  tabProps: PropTypes.object,
  lastIndex: PropTypes.number,
}

function GigaProductInfo(props) {
  const {
    navigation: { goBack, getParam },
  } = props

  const product = getParam('item', {})

  const [isBgLoading, setBgLoading] = useState(true)

  const [tabHeight, setTabHeight] = useState(height - 84)
  const measureContainer = event => {
    const { height: contaoinerHeight } = event.nativeEvent.layout
    setTabHeight(contaoinerHeight - 84)
  }

  const insets = useSafeAreaInsets()

  const [routes] = useState([
    // {key: 'see-all', title: 'See all'}
  ])

  const [routeData] = useState([
    // []
  ])

  const [browserState, setBrowserState] = useState({
    isVisible: false,
    url: '',
  })
  const openBrowser = (urlKey, contentManager = false, placeholders = []) => {
    const url = contentManager
      ? ContentManager.translate(urlKey, placeholders)
      : urlKey
    setBrowserState({
      isVisible: true,
      url: url,
    })
  }
  const closeBrowser = () => {
    setBrowserState({
      isVisible: false,
      url: '',
    })
  }

  const renderTabs = useMemo(
    () => (
      <NavigationContainer>
        <Tab.Navigator
          lazy
          lazyPreloadDistance={1}
          style={[styles.tabContainer, { height: tabHeight }]}
          sceneContainerStyle={styles.scene}
          tabBar={tabProps => (
            <TabRoutes tabProps={tabProps} lastIndex={routes.length - 1} />
          )}
          initialLayout={initialLayout}>
          {routes.map((category, index) => (
            <Tab.Screen
              key={index}
              name={category.title}
              initialParams={{ index: index }}>
              {() => (
                <List
                  key={'list-' + index}
                  items={routeData?.[index] ?? []}
                  i={index}
                />
              )}
            </Tab.Screen>
          ))}
        </Tab.Navigator>
      </NavigationContainer>
    ),
    [routes, routeData, tabHeight],
  )

  return (
    <View style={styles.screenWrapper}>
      <StatusBar
        translucent
        barStyle="dark-content"
        backgroundColor={Colors.transparent}
        animated
      />
      <ImageBackground
        source={{ uri: product.image_url }}
        resizeMode="cover"
        style={styles.headerBackground(insets.top)}
        onLoad={() => {
          setBgLoading(false)
          StatusBar.setBarStyle('light-content')
        }}>
        {isBgLoading ? (
          <ContentLoader
            speed={2}
            width={'100%'}
            height={210 + insets.top}
            backgroundColor={Colors.offWhite}
            foregroundColor={Colors.veryLightPinkTwo}
            style={styles.coverLoading}>
            <Rect x="0" y="0" rx="0" ry="0" width="100%" height="100%" />
          </ContentLoader>
        ) : null}
        <View style={styles.cover}>
          <View pointerEvents="box-none" style={styles.inCoverContent}>
            <TouchableOpacity onPress={() => goBack()} style={{}}>
              <Icon
                name={images.arrowLeft}
                type="image"
                resizeMode="contain"
                size={24}
                style={[styles.backIcon, styles['backIconNoBg_' + isBgLoading]]}
              />
            </TouchableOpacity>
            <FlatList
              horizontal
              showsHorizontalScrollIndicator={false}
              style={styles.tagsContainer}
              contentContainerStyle={styles.tagsContent}
              data={product.tags || []}
              renderItem={({ item, index }) => (
                <VfText
                  key={'benefit-' + index}
                  i18nKey={item}
                  size="footnote"
                  color={Colors.thinDark}
                  style={styles.tag}
                />
              )}
            />
          </View>
        </View>
      </ImageBackground>
      <SafeAreaView style={styles.container} edges={['right', 'left']}>
        <View
          style={styles.fillRemainingSpace}
          onLayout={event => measureContainer(event)}>
          <ScrollView
            showsVerticalScrollIndicator={false}
            nestedScrollEnabled={true}>
            <VfText
              i18nKey={product.name}
              size="h3"
              weight="bold"
              style={styles.title}
            />
            <VfText i18nKey={product.description} style={styles.desc} />

            {/* {renderTabs} */}
          </ScrollView>
        </View>
        <View style={styles.ctaContainer(insets.bottom)}>
          <VFButton
            type="primary"
            title="giga_go_to_payment"
            onPress={() => openBrowser('giga_link_abcom', true)}
            disabled={false}
          />
        </View>
        <Browser browserState={browserState} closeBrowser={closeBrowser} />
      </SafeAreaView>
    </View>
  )
}

GigaProductInfo.defaultProps = {}

GigaProductInfo.propTypes = {
  navigation: PropTypes.object,
  route: PropTypes.object,
}

export default GigaProductInfo
